import { AuthRequired } from "@redotech/redo-merchant-app-common/auth";
import { loginDestinationRoutes } from "@redotech/redo-merchant-app-common/routing/login-destination-routes";
import { RouteObject } from "react-router-dom";

export const oauthRoutes: RouteObject[] = [
  {
    path: loginDestinationRoutes.oauth.authorize,
    async lazy() {
      const { Authorize } = await import("./authorize");
      return {
        element: (
          <AuthRequired>
            <Authorize />
          </AuthRequired>
        ),
      };
    },
  },
  {
    path: loginDestinationRoutes.oauth.connect,
    async lazy() {
      const { Connect } = await import("./connect");
      return {
        element: (
          <AuthRequired>
            <Connect />
          </AuthRequired>
        ),
      };
    },
  },
];
